var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimplifiedOnboardingModal',{on:{"close":_vm.close},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}})
}
var staticRenderFns = []

export { render, staticRenderFns }